// Work queues stop for the frame when it runs out of time. Where they stop
// depends on the machine, so the cut-off is recorded with the replay input and
// a replay stops at the same item instead of measuring time.
let replayCutoffs = null;
let recordCutoff = null;

export const setReplayCutoffs = cutoffs => {
	replayCutoffs = cutoffs;
};

export const onFrameBudgetCutoff = callback => {
	recordCutoff = callback;
};

export const frameBudgetExhausted = (queue, started, limitMS, examined) => {
	if(replayCutoffs) return replayCutoffs[queue] === examined;
	if(examined === 0 || performance.now() - started < limitMS) return false;
	recordCutoff?.(queue, examined);
	return true;
};
